import {
  baudRateItems,
  dataBitItems,
  getOptions,
  parityItems,
  stopBitItems,
  workModeItems
} from '@/shared/SelectData'
import { SelectItem } from '@/shared/SelectItem'
import { getFormatMessage } from '@/utils/utils'
import { Col, Form, Input, Row, Select } from 'antd'
import React from 'react'

export const TemplatePlcSerial = (props: { portNoItems: SelectItem[] }) => {
  const formatMessage = getFormatMessage()
  const labelCol = {
    xs: { span: 12 },
    sm: { span: 5 }
  }

  return (
    <div>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.portNo'
            })}
            name={['serial', 'portNo']}
          >
            <Select>{getOptions(props.portNoItems)}</Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.workModel'
            })}
            name={['serial', 'workMode']}
          >
            <Select>{getOptions(workModeItems)}</Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.baudRate'
            })}
            name={['serial', 'baudRate']}
          >
            <Select>{getOptions(baudRateItems)}</Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.dataBits'
            })}
            name={['serial', 'dataBits']}
          >
            <Select>{getOptions(dataBitItems)}</Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.stopBits'
            })}
            name={['serial', 'stopBits']}
          >
            <Select>{getOptions(stopBitItems)}</Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.parity'
            })}
            name={['serial', 'parity']}
          >
            <Select>{getOptions(parityItems)}</Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            labelCol={labelCol}
            label={formatMessage({
              id: 'app.template.plc.edit.compatibleModels'
            })}
            name='compatibleModels'
          >
            <Input.TextArea disabled={true} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}
